<div class="m-3 tennis-tournament-info">
  <h4 class="font-weight-bold text-uppercase mb-3">{{ 'web.tournament_info' | translate }}</h4>

  @if (tennisTournamentInfo?.surface) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_groundtype' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ 'web.ground-type_' + tennisTournamentInfo?.surface | translate }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.numberOfSets) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_numberofsets' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.numberOfSets }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.prize_money) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_totalprizemoney' | translate }}</strong>
      </div>
      <div class="col-6 text-right">
        {{ tennisTournamentInfo?.prize_money | localeCurrency : tennisTournamentInfo?.prize_currency }}
      </div>
    </div>
  }
  @if (tennisTournamentInfo?.startDate) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_startdate' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.startDate | date : 'd. M. y' }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.endDate) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_enddate' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.endDate | date : 'd. M. y' }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.continent) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_continent' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.continent! | translate }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.complex) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.complex' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.complex }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.numberOfCompetitors) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_numberofcompetitors' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.numberOfCompetitors }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.number_of_competitors) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_numberofcompetitors' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.number_of_competitors }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.number_of_qualified_competitors) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_number_of_qualified_competitors' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.number_of_qualified_competitors }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.number_of_scheduled_matches) {
    <div class="row py-1 small">
      <div class="col-6">
        <strong>{{ 'web.tennis_number_of_scheduled_matches' | translate }}</strong>
      </div>
      <div class="col-6 text-right">{{ tennisTournamentInfo?.number_of_scheduled_matches }}</div>
    </div>
  }
  @if (tennisTournamentInfo?.winner_last_season) {
    <div class="row py-1 small">
      <div class="col-6">
        @if (
          !tennisTournamentInfo.winner_last_season?.type ||
          tennisTournamentInfo.winner_last_season.type === 'last'
          ) {
          <strong
            >{{ 'web.winner_last_season' | translate }}</strong
            >
          }
          @if (
            tennisTournamentInfo.winner_last_season?.type ||
            tennisTournamentInfo.winner_last_season.type === 'current'
            ) {
            <strong
              >{{ 'web.winner_current_season' | translate }}</strong
              >
            }
          </div>
          <div class="col-6 text-right">
            <a
                [routerLink]="[
                    '/page/sport/participant/' +
                        sportName +
                        '-' +
                        sportId +
                        '/' +
                        tennisTournamentInfo?.winner_last_season?.id
                ]"
              >
              {{ tennisTournamentInfo?.winner_last_season?.name }}</a
              >
            </div>
          </div>
        }
        @if (tennisTournamentInfo?.level) {
          <div class="row py-1 small">
            <div class="col-6">
              <strong>{{ 'web.tournament_level' | translate }}</strong>
            </div>
            <div class="col-6 text-right">{{ 'web.tournament_level_' + tennisTournamentInfo?.level | translate }}</div>
          </div>
        }
        @if (country) {
          <div class="row py-1 small">
            <div class="col-6">
              <strong>{{ 'web.country' | translate }}</strong>
            </div>
            <div class="col-6 text-right">
              <img
                width="16"
                height="16"
                loading="lazy"
                class="mr-1 img-fluid--wauto"
                [src]="'/img/flags/4x3/' + country + '.svg'"
                [attr.alt]="iso"
                />
            </div>
          </div>
        }
      </div>
